/**
 * Module-level store for pre-filling the login screen after logout.
 * Kept in a separate file to avoid circular dependencies between
 * AuthContext and LoginScreen.
 * Password is stored in RAM only — never persisted to disk.
 */

let _login = '';
let _password = '';

// Saved credentials from last successful login (RAM only)
let _savedLogin = '';
let _savedPassword = '';

/** Called after a successful login to cache credentials for post-logout prefill */
export const saveCredentialsForPrefill = (login: string, password: string): void => {
  _savedLogin = login;
  _savedPassword = password;
};

/**
 * Keeps the currently typed credentials alive across transient LoginScreen
 * remounts (for example while AuthContext toggles its loading state).
 * This is deliberately module memory only: a cold app restart must never
 * restore the password.
 */
export const saveLoginDraft = (login: string, password: string): void => {
  _login = login;
  _password = password;
};

/** Called on logout — activates the saved credentials as prefill */
export const activatePrefill = (): void => {
  _login = _savedLogin;
  _password = _savedPassword;
};

export const getLoginPrefill = (): { login: string; password: string } => ({
  login: _login,
  password: _password,
});

export const clearLoginPrefill = (): void => {
  _login = '';
  _password = '';
};
